import React from "react";
import { useAuthContext } from "../context/AuthContext";
import { removeToken } from "../helpers";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const { setUser } = useAuthContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    removeToken();
    setUser(undefined);
    navigate("/");
  };

  return (
    // <img
    //   src="../images/exit.svg"
    //   alt="Mail"
    //   onClick={handleLogout}
    //   className="logout-icon"
    // />
    <div
      className="nav-link btn m-1 p-2 main-menu-item nav-text"
      onClick={handleLogout}
    >
      Odhlásit se
    </div>
  );
};

export default Logout;
